import gqlRequest from 'graphql/generic';

type sendNotificationParams = {
  content: string,
  orderId: string,
  subject: string,
  to: string,
  bcc: string,
  cc: string,
  replyTo: string
};

const querySendNotification = `
  mutation SendNotification($content: String!, $orderId: ID!, $subject: String!, $to: String!, $bcc: String, $cc: String, $replyTo: String) {
    sendNotification(content: $content, order_id: $orderId, subject: $subject, to: $to, bcc: $bcc, cc: $cc, reply_to: $replyTo)
  }
`;

export const sendNotification = (params: sendNotificationParams) =>
  gqlRequest(querySendNotification, params);
